import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useState } from 'react'
import { IconButton, Toolbar, Tooltip, styled, useTheme } from '@mui/material'
import { useDebounce } from 'use-debounce'
import { IconBackspace, IconCirclePlus, IconFilter } from '@tabler/icons-react'
import { Search, StyledInputBase } from '../../../../../../config'
import { UsersFilterDrawer } from './UsersFilterDrawer'
import { useDispatch, useSelector } from '../../../../../../store/store'
import { setExternalUsersFilterQuerySearch } from '../../../../../../store/slices/filters/filters'
import { dialogToggle } from '../../../../../../store/slices/dialog'

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const RemoveSearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const UsersEnhancedTableToolbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const handleOpen = () => dispatch(dialogToggle(true))

  const { externalUsersFilterQuerySearch } = useSelector((state) => state.filters)
  const [searchValue, setSearchValue] = useState(externalUsersFilterQuerySearch || '')
  const [debouncedSearchValue] = useDebounce(searchValue, 300)

  const dispatch = useDispatch()
  const theme = useTheme()

  useEffect(() => {
    dispatch(setExternalUsersFilterQuerySearch(debouncedSearchValue))
  }, [debouncedSearchValue, dispatch])

  return (
    <>
      <Toolbar>
        <Search sx={{ flex: '1 1 100%', display: 'flex', alignContent: 'baseline' }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            autoFocus
          />
          {externalUsersFilterQuerySearch && (
            <RemoveSearchIconWrapper
              onClick={() => dispatch(setExternalUsersFilterQuerySearch(null))}
            >
              <IconBackspace size="24px" className="removeIcon" />
            </RemoveSearchIconWrapper>
          )}
        </Search>
        <Tooltip onClick={() => setDrawerOpen(!drawerOpen)} title="Filter list">
          <IconButton>
            <IconFilter size="20px" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Add new" onClick={handleOpen}>
          <IconButton>
            <IconCirclePlus
              stroke="none"
              size="35px"
              fill={theme.palette.primary.main}
              color={theme.palette.primary.light}
            />
          </IconButton>
        </Tooltip>
        <UsersFilterDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      </Toolbar>
    </>
  )
}
